import { render, staticRenderFns } from "./ScoringDialogThirdLevelTabComponent.vue?vue&type=template&id=3057d1ba&scoped=true"
import script from "./ScoringDialogThirdLevelTabComponent.js?vue&type=script&lang=js&external"
export * from "./ScoringDialogThirdLevelTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./ScoringDialogThirdLevelTabComponent.vue?vue&type=style&index=0&id=3057d1ba&prod&scoped=true&lang=scss"
import style1 from "./ScoringDialogThirdLevelTabComponent.vue?vue&type=style&index=1&id=3057d1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057d1ba",
  null
  
)

export default component.exports